var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/rocket_blue.svg"),"alt":"rocket icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }